module.exports = __webpack_public_path__ + "ae60a7f636411c3f57dd5a964c8221bb.svg";